import React from "react"
import { createRoot, hydrateRoot } from "react-dom/client"
const AntLess = process.env.NODE_ENV === "development" && require("antd/dist/antd.less")
const App = require("./App").default

const container = document.getElementById('root')

const root = createRoot(container)
root.render(<><App /></>)

